import { useEffect, useState } from 'react';
import { subscribeToCoApprovalDjSession } from '../services/coApprovalDj';

// Whether this event has an active co-approval DJ link; the DJ's screens make no hold calls without one (ITER-194)
export function useCoApprovalDjActive(eventId: string | undefined, djId: string | undefined): boolean {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!eventId || !djId) {
      setActive(false);
      return;
    }
    return subscribeToCoApprovalDjSession(eventId, djId, session => setActive(session?.status === 'active'));
  }, [eventId, djId]);

  return active;
}
